<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00080.installation.configurationRX' | translate"
      [description]="
        'P00080.installation.configurationRX.description' | translate
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00080.installation.alIConsigneAlarmBasseRX.title' | translate"
      [titleListe]="
        'P00080.installation.alIConsigneAlarmBasseRX.listTitle' | translate
      "
      [value]="actionStack!.getValue('alIConsigneAlarmBasseRX')"
      [liste]="P00080ConsignRXBas()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Altimeo_Installation,
          'alIConsigneAlarmBasseRX',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="
        'P00080.installation.alIConsigneAlarmHauteRX.listTitle' | translate
      "
      [value]="actionStack!.getValue('alIConsigneAlarmHauteRX')"
      [liste]="P00080ConsignRXHaut()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Altimeo_Installation,
          'alIConsigneAlarmHauteRX',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
